export default "__VITE_ASSET__CCARU2Cl__"